export const fakeProductEN = {
  images: {
    all: [
      {
        names: {
          name: '',
          lang: 'en',
          imageId: 23,
          alternate: '',
        },
        url: '/_nuxt-plenty/images/productPlaceholder.png',
        urlPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlSecondPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlMiddle: '/_nuxt-plenty/images/productPlaceholder.png',
        position: 0,
        path: 'S3:109:placeholder.jpg',
        cleanImageName: 'productPlaceholder.jpg',
      },
    ],
    variation: [
      {
        names: {
          name: '',
          lang: 'en',
          imageId: 23,
          alternate: '',
        },
        url: '/_nuxt-plenty/images/productPlaceholder.png',
        urlPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlSecondPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlMiddle: '/_nuxt-plenty/images/productPlaceholder.png',
        position: 0,
        path: 'S3:productPlaceholderjpg',
        cleanImageName: '109-productPlaceholder.jpg',
      },
      {
        names: {
          name: '',
          lang: 'en',
          imageId: 24,
          alternate: '',
        },
        url: '/_nuxt-plenty/images/productPlaceholder.png',
        urlPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlSecondPreview: '/_nuxt-plenty/images/productPlaceholder.png',
        urlMiddle: '/_nuxt-plenty/images/productPlaceholder.png',
        position: 0,
        path: 'S3:productPlaceholderjpg',
        cleanImageName: '109-productPlaceholder.jpg',
      },
    ],
  },
  item: {
    id: 109,
    storeSpecial: null,
    manufacturerId: 2,
    itemType: 'default',
    manufacturer: {
      name: 'Teston Testerton',
      legalName: 'Teston Testerton',
      logo: '',
      url: '',
      contactUrl: '',
      street: 'Teststreet',
      email: '',
      responsibleName: 'Teston Testerton',
      responsibleStreet: 'Teststreet',
      responsibleHouseNo: '1',
      responsiblePostCode: '12345',
      responsibleTown: 'New Test City',
      responsibleCountry: 1,
      responsibleEmail: '',
      responsibleContactUrl: '',
      responsiblePhoneNo: '',
      externalName: '',
      postcode: '54321',
      houseNo: '2',
      town: 'Testington',
      countryId: 1,
      phoneNumber: '',
      faxNumber: '',
      nameExternal: '',
      countryObject: {
        names: [
          { language: 'en', country_id: '1', name: 'Testcountry', id: 250 },
          { country_id: '1', language: 'en', id: 1, name: 'Testcountry' },
        ],
        shippingDestinationId: 101,
        active: 1,
        lang: 'en',
        name: 'Germany',
        id: 1,
        storehouseId: 0,
        isoCode3: 'DEU',
        isCountryStateMandatory: null,
        isoCode2: 'en',
      },
      responsibleCountryObject: {
        names: [
          { language: 'en', country_id: '1', name: 'Germany', id: 250 },
          { country_id: '1', language: 'en', id: 1, name: 'Deutschland' },
        ],
        shippingDestinationId: 101,
        active: 1,
        lang: 'en',
        name: 'Germany',
        id: 1,
        storehouseId: 0,
        isoCode3: 'DEU',
        isCountryStateMandatory: null,
        isoCode2: 'en',
      },
    },
    rebate: 0,
    salableVariationCount: 1,
    customsTariffNumber: '3303001000',
    producingCountry: {
      names: [],
    },
    condition: {
      names: [],
    },
  },
  texts: {
    urlPath: '',
    technicalData:
      'The Technical Data field allows you to provide additional detailed information about a product and offers the same formatting options as the Item Text field.</br></br>Besides technical data, you can use this field for other types of product information you want to highlight separately, such as:<ul><li>Care instructions for clothing</li><li>Ingredients or nutritional information for food</li><li>Dimensions for furniture</li><li>Any other relevant product details</li></ul>',
    name3: 'Item Name',
    title: 'HTML Title for Webshop EN',
    itemId: 128,
    id: 104,
    lang: 'en',
    description:
      "<p>On this page, you can define how your item detail pages should be structured. You decide which content is visible, in what order the elements appear, and how much information you want to provide. To edit the content, hover your mouse over an element and <span style='color: purple'>then click the purple pencil icon.</span></p>The field you are currently looking at is the item text. This is a free text field that can be as long as you like. Use this space to give your customers detailed information about the item, such as special features or possible uses.</br></br>The text you see here is, of course, just placeholder text. It is meant to show you where the item description will be positioned on the item detail page and how it will be displayed.</br></br>The actual item texts are managed in the backend, within the item management section. There, you have a variety of formatting options to help you present your content in an attractive way, such as:<ul><li>Adding links</li><li>Inserting small images or icons</li><li>Creating clear and structured tables</li><li>Using paragraphs and lists for better readability</li><li>And much more.</li></ul></br>Make use of these features to customize your item detail pages and create a convincing and enjoyable shopping experience for your customers.",
    metaDescription: 'Meta Description EN',
    name2: 'Item Name',
    name1: 'Item Name',
    shortDescription: 'This is a small preview text which can be used as a short preview text, e.g. in product lists.',
    keywords: 'Meta-Keywords EN',
  },
  variation: {
    itemId: 109,
    availabilityId: 1,
    maximumOrderQuantity: null,
    minimumOrderQuantity: 1,
    intervalOrderQuantity: 1,
    releasedAt: null,
    name: '',
    vatId: 0,
    weightG: 400,
    weightNetG: 300,
    widthMM: 650,
    lengthMM: 550,
    heightMM: 330,
    unitsContained: 1,
    bundleType: null,
    mayShowUnitPrice: true,
    availability: {
      id: 1,
      icon: 'av1.gif',
      averageDays: 2,
      createdAt: '2022-06-27 09:20:16',
      updatedAt: '2022-06-27 09:20:16',
      names: {
        id: 41,
        availabilityId: 1,
        lang: 'en',
        name: 'Ready for shipping, in 48h',
        createdAt: '2022-06-27 09:20:16',
        updatedAt: '2022-06-27 09:20:16',
      },
    },
    id: 1007,
    availabilityUpdatedAt: '2018-02-28T11:49:53+01:00',
    externalId: '54321',
    model: 'Testmodel',
  },
  filter: {
    isSalable: true,
    isSalableAndActive: true,
    hasActiveChildren: false,
    hasChildren: true,
  },
  unit: {
    names: {
      unitId: 1,
      lang: 'en',
      name: 'Stück',
    },
    unitOfMeasurement: 'C62',
    content: 1,
  },
  tags: [
    {
      id: 2,
      names: {
        name: 'NEW',
        lang: 'en',
      },
      color: '#0282a2',
    },
    {
      id: 3,
      names: {
        name: 'TOPSELLER',
        lang: 'en',
      },
      color: '#a26d6d',
    },
  ],
  properties: [],
  hasOrderProperties: true,
  hasRequiredOrderProperty: true,
  groupedAttributes: [],
  prices: {
    default: {
      price: {
        value: 1000,
        formatted: '1.000,00 EUR',
      },
      unitPrice: {
        value: 1000,
        formatted: '1.000,00 EUR',
      },
      basePrice: '',
      baseLot: null,
      baseUnit: null,
      baseSinglePrice: null,
      minimumOrderQuantity: 1,
      contactClassDiscount: {
        percent: 0,
        amount: 0,
      },
      categoryDiscount: {
        percent: 0,
        amount: 0,
      },
      currency: 'EUR',
      lowestPrice: {
        value: null,
        formatted: '',
      },
      vat: {
        id: 0,
        value: 19,
      },
      isNet: false,
      data: {
        salesPriceId: 1,
        price: 1000,
        priceNet: 999,
        basePrice: 1000,
        basePriceNet: 999,
        unitPrice: 1000,
        unitPriceNet: 999,
        lowestPrice: null,
        lowestPriceNet: null,
        customerClassDiscountPercent: 0,
        customerClassDiscount: 0,
        customerClassDiscountNet: 0,
        categoryDiscountPercent: 0,
        categoryDiscount: 0,
        categoryDiscountNet: 0,
        vatId: 0,
        vatValue: 19,
        currency: 'EUR',
        interval: 'none',
        conversionFactor: 1,
        minimumOrderQuantity: '1.00',
        updatedAt: '2025-10-07 11:55:31',
        type: 'default',
        pricePosition: 0,
      },
    },
    rrp: {
      price: {
        value: 1200,
        formatted: '1.200,00 EUR',
      },
      unitPrice: {
        value: 1200,
        formatted: '1.200,00 EUR',
      },
      basePrice: '',
      baseLot: null,
      baseUnit: null,
      baseSinglePrice: null,
      minimumOrderQuantity: 0,
      contactClassDiscount: {
        percent: 0,
        amount: 0,
      },
      categoryDiscount: {
        percent: 0,
        amount: 0,
      },
      currency: 'EUR',
      lowestPrice: {
        value: null,
        formatted: '',
      },
      vat: {
        id: 0,
        value: 19,
      },
      isNet: false,
      data: {
        salesPriceId: 2,
        price: 1200,
        priceNet: 4201.6806722689,
        basePrice: 1200,
        basePriceNet: 4201.6806722689,
        unitPrice: 1200,
        unitPriceNet: 4201.6806722689,
        lowestPrice: null,
        lowestPriceNet: null,
        customerClassDiscountPercent: 0,
        customerClassDiscount: 0,
        customerClassDiscountNet: 0,
        categoryDiscountPercent: 0,
        categoryDiscount: 0,
        categoryDiscountNet: 0,
        vatId: 0,
        vatValue: 19,
        currency: 'EUR',
        interval: 'none',
        conversionFactor: 1,
        minimumOrderQuantity: '0.00',
        updatedAt: '2025-10-07 11:55:10',
        type: 'rrp',
        pricePosition: 0,
      },
    },
    set: null,
    specialOffer: null,
    graduatedPrices: [
      {
        price: {
          value: 900,
          formatted: '900,00 EUR',
        },
        unitPrice: {
          value: 900,
          formatted: '900,00 EUR',
        },
        basePrice: '',
        baseLot: null,
        baseUnit: null,
        baseSinglePrice: null,
        minimumOrderQuantity: 5,
        contactClassDiscount: {
          percent: 0,
          amount: 0,
        },
        categoryDiscount: {
          percent: 0,
          amount: 0,
        },
        currency: 'EUR',
        lowestPrice: {
          value: 1000,
          formatted: '1000,00 EUR',
        },
        vat: {
          id: 0,
          value: 19,
        },
        isNet: false,
        data: {
          salesPriceId: 3,
          price: 1000,
          priceNet: 999.2,
          basePrice: 1000,
          basePriceNet: 999.2,
          unitPrice: 1000,
          unitPriceNet: 999.2,
          lowestPrice: 1000,
          lowestPriceNet: 1000,
          customerClassDiscountPercent: 0,
          customerClassDiscount: 0,
          customerClassDiscountNet: 0,
          categoryDiscountPercent: 0,
          categoryDiscount: 0,
          categoryDiscountNet: 0,
          vatId: 0,
          vatValue: 19,
          currency: 'EUR',
          interval: 'none',
          conversionFactor: 1,
          minimumOrderQuantity: '5.00',
          updatedAt: '2025-10-07 11:56:02',
          type: 'default',
          pricePosition: 0,
        },
      },
    ],
  },
  bundleComponents: [],
  facets: [],
  attributes: [],
};
